<div class="padding column background-grey-300 grey-color-700">
  <h3>{{ 'ImpersonateModal.title' | translate }}</h3>
  <span [innerHTML]="'ImpersonateModal.text' | translate"></span>
</div>
<div class="form-container">
  <span>{{ 'ImpersonateModal.email' | translate }}</span>
  <form class="column" [formGroup]="emailForm">
    <div class="column gap-sm no-padding">
      <mat-form-field floatLabel="always">
        <input
          matInput
          placeholder="{{ 'ImpersonateModal.placeholder' | translate }}"
          type="text"
          formControlName="email"
        />
        <mat-error *ngIf="emailForm.get('email')?.hasError('required')" class="modal__inputs--error">{{
          'InviteUserComponent.requiredEmail' | translate
        }}</mat-error>
        <mat-error *ngIf="emailForm.get('email')?.hasError('email')" class="modal__inputs--error">{{
          'InviteUserComponent.invalidEmail' | translate
        }}</mat-error>
      </mat-form-field>
    </div>
  </form>
  <div class="vertical-center" *ngIf="canViewLogs">
    <mat-checkbox (change)="activateLogs = $event.checked"></mat-checkbox>
    {{ 'ImpersonateModal.checkbox' | translate }}
  </div>
  <div class="horizontal-end">
    <button appLoadingButton mat-raised-button color="primary" [disabled]="emailForm.invalid" (click)="getToken()">
      {{ 'ImpersonateModal.buttonText' | translate }}
    </button>
  </div>
</div>
